/// <reference path='../../interfaces/interfaces.d.ts' />
import functions = require('../../global/functions');

'use strict';

class TourController {
    public static $inject = [
        '$state',
        '$stateParams',
        'User',
        'Employee'
    ];

    public page = 1;
    public employee;
    public dismiss_tour;
    public act;

    constructor (
        private $state: ng.ui.IStateService,
        private $stateParams: ng.ui.IStateParamsService,
        private User: IUserService,
        private Employee: IEmpService
      ) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.act = functions.act;
      if (User.getCurrentUser().userData.extra.dismiss_tour) {
        this.$state.go('root.home');
      }
    }

    public next = () => {
      if (this.page === 5) {
        this.dismissTour();
      } else {
        this.page += 1;
      }
    }

    public skip = () => {
      if (this.dismiss_tour) {
        this.dismissTour();
      } else {
        this.$state.go('root.home');
      }
    }

    public dismissTour(): void {
      this.Employee.loadEmployee(this.User.getCurrentUser().userData.id).then((response: Restangular.IResponse) => {
          this.employee = response;
          this.Employee.dismissTour(this.employee).then(() => {
            this.$state.go('root.home');
          });
      });
    }
}

angular.module('beneple.global')
    .controller('TourController', TourController);



// WEBPACK FOOTER //
// ./frontend/scripts/global/controllers/tour.controller.ts